<template>
  <div class="ListNotification">
    <v-card class="mx-auto card-notification">
      <v-list subheader class="list-item">
        <v-subheader class="list-header">
          {{ $t('top-page.header', { split: '/' }) }}</v-subheader
        >
        <v-list-item-group v-if="dataNoti.length > 0">
          <template v-for="(item, index) in dataNoti">
            <v-list-item :key="item.title" @click="readNoti(item)">
              <template>
                <v-list-item-content class="list-content">
                  <v-list-item-title
                    class="text-title"
                    v-text="item.subject"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    class="text--primary"
                    v-text="item.header"
                  ></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text>
                    {{
                      convertDateAndTime(item.created_at)
                    }}</v-list-item-action-text
                  >
                </v-list-item-action>
              </template>
            </v-list-item>
            <v-divider
              v-if="index < dataNoti.length - 1"
              :key="index"
            ></v-divider>
          </template>
        </v-list-item-group>
        <v-list-item-group v-else>
          <v-list-item-content>
            <v-list-item-title
              v-html="$t('top-page.no-notification', { split: '<br />' })"
            >
            </v-list-item-title> </v-list-item-content
        ></v-list-item-group>
      </v-list>
      <!-- <v-divider></v-divider>
      <v-list subheader class="list-item">
        <v-subheader class="list-header">
          {{
            $t('recruitment-letter-page.header', { split: '/' })
          }}</v-subheader
        >
        <v-list-item-group v-if="dataScoutMail.length > 0">
          <template v-for="(item, index) in dataScoutMail">
            <v-list-item :key="item.title" @click="readScoutMail(item)">
              <template>
                <v-list-item-content class="list-content">
                  <v-list-item-title
                    class="text-title"
                    v-text="item.title"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    class="text--primary"
                    v-text="item.body"
                  ></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text
                    v-text="item.created_at"
                  ></v-list-item-action-text>
                </v-list-item-action>
              </template>
            </v-list-item>
            <v-divider
              v-if="index < dataScoutMail.length - 1"
              :key="index"
            ></v-divider>
          </template>
        </v-list-item-group>
        <v-list-item-group v-else>
          <v-list-item-content>
            <v-list-item-title
              v-html="$t('top-page.no-notification', { split: '<br />' })"
            ></v-list-item-title> </v-list-item-content
        ></v-list-item-group>
      </v-list> -->
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ListNotification',
  data() {
    return {};
  },
  methods: {
    readNoti(item) {
      this.$emit('updateProps', false);
      this.$router.replace(
        { name: 'top-applicant', query: { noti: item.id } },
        () => {}
      );
    },

    readScoutMail(item) {
      this.$emit('updateProps', false);
      this.$router.replace(
        { name: 'mail-box', query: { noti: item.id } },
        () => {}
      );
    }
  },

  computed: {
    ...mapGetters({
      dataNoti: 'getNotiArray',
      dataScoutMail: 'getScoutMailArray'
    })
  }
};
</script>
<style lang="scss" scoped>
@import '@/style/devices.scss';

.ListNotification {
  position: absolute;
  z-index: 1000 !important;
  top: 25px;
  right: 8px;
  min-width: 20rem;

  .card-notification {
    border-radius: 10px;
    box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.4);
    width: 25rem;
    max-width: 25rem;
    overflow-y: scroll;
    max-height: 60vh;

    &::-webkit-scrollbar {
      width: 1rem;
      max-height: 10px !important;
    }
    &::-webkit-scrollbar-thumb {
      border: 4px solid rgba(0, 0, 0, 0);
      background-clip: padding-box;
      border-radius: 10px;
      // background-color: rgba(0, 0, 0, 0.15);
      box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05),
        inset 1px 1px 0px rgba(0, 0, 0, 0.05);

      background-color: #bcc0c4;
    }
    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }

    .list-item {
      margin-left: 1rem;
      .list-header {
      }
      .list-content {
        .text-title {
          font-weight: bold;
          text-align: left;
        }
      }
    }
  }
}

@include mobile {
  .ListNotification {
    min-width: 15rem;
    right: -15px !important;
    font-size: 0.9rem;
    .card-notification {
      max-width: 15rem;
    }
  }
}

@include small-mobile {
  .ListNotification {
    left: -170px !important;
  }
}
</style>
